export { isStringAuthorizeHtml, authorizeHtml, unprotectAuthorizedHtml } from './protectStrings';
export function mapErrors(response, fields) {
  if (!response) return {};
  const errors = {};
  if (typeof response.message === 'string') {
    errors._error = response.message;
  }
  if (Array.isArray(response.errors)) {
    response.errors.forEach(error => {
      let key = error.name;
      if (fields) {
        key = fields[error.name] ? fields[error.name] : '_error';
      }
      errors[key] = (errors[key] ? `${errors[key]}\n` : '') + error.description;
    });
  }
  return errors;
}
export class FormValidationError extends Error {
  constructor(message, errors = {}) {
    super(message);
    this.name = 'FormValidationError';
    this.errors = errors;
  }
}
export function nest(path, value) {
  const shouldNest = /\./.test(path);
  if (shouldNest) {
    const splittedPath = path.split('.');
    const firstKey = splittedPath.shift();
    return {
      [firstKey]: nest(splittedPath.join('.'), value)
    };
  }
  return {
    [path]: value
  };
}